module.exports = __webpack_public_path__ + "screenshot.63f9530c98f71c988fd111f1ab66e21d.png";